import React from 'react';
import styled from 'styled-components';
import { Sparkles, Link2, Gift } from 'lucide-react';
import breakpoints from 'theme/breakpoints';
import {
    Section,
    SectionInner,
    Eyebrow,
    SectionTitle,
    SectionSubtitle,
    FeatureGrid,
    FeatureCard,
    FeatureIconBox,
    FeatureTitle,
    FeatureText,
    campaign,
} from './shared';

const ASSETS = '/assets/images/promo/3-anos';

const FEATURES = [
    {
        icon: Sparkles,
        title: 'Cara nova',
        text: 'Logo nova, essência de sempre: mais estrutura e mais clareza pra quem produz.',
    },
    {
        icon: Link2,
        title: 'Ecossistema conectado',
        text: 'Produtores e estabelecimentos, cada vez mais pertinho dentro da mesma plataforma.',
    },
    {
        icon: Gift,
        title: 'Programa de afiliados',
        text: 'A novidade da fase: indica a Whizr pra galera e ganha pelas indicações aprovadas.',
    },
];

export default function EcosystemSection() {
    return (
        <Section>
            <SectionInner>
                <Header>
                    <TextCol>
                        <Eyebrow>Essa nova fase</Eyebrow>
                        <SectionTitle>3 anos de rolê, muita coisa pra descobrir</SectionTitle>
                        <SectionSubtitle>
                            São 3 anos do "o que tem pra fazer hoje?", do "já comprou o ingresso
                            pro rolê?" — de conexões entre pessoas, produtores, estabelecimentos
                            e experiências que viraram história.
                        </SectionSubtitle>
                    </TextCol>

                    <ImageCol>
                        <PeoplePhoto src={`${ASSETS}/fotos-conexoes.png`} alt="Pessoas curtindo eventos na Whizr" />
                        <ConnectionArt src={`${ASSETS}/conexao-pontos.png`} alt="" aria-hidden="true" />
                    </ImageCol>
                </Header>

                <FeatureGrid>
                    {FEATURES.map(({ icon: FeatureIcon, title, text }, i) => (
                        <FeatureCard key={i}>
                            <FeatureIconBox>
                                <FeatureIcon size={20} />
                            </FeatureIconBox>
                            <FeatureTitle>{title}</FeatureTitle>
                            <FeatureText>{text}</FeatureText>
                        </FeatureCard>
                    ))}
                </FeatureGrid>
            </SectionInner>
        </Section>
    );
}

const Header = styled.div`
    display: flex;
    flex-direction: column;
    gap: 24px;

    @media screen and (min-width: ${breakpoints.lg}) {
        flex-direction: row;
        align-items: center;
        gap: 40px;
    }
`;

const TextCol = styled.div`
    flex: 1.2;
`;

const ImageCol = styled.div`
    position: relative;
    flex: 1;
    display: none;

    @media screen and (min-width: ${breakpoints.lg}) {
        display: block;
    }
`;

const PeoplePhoto = styled.img`
    width: 100%;
    max-width: 340px;
    height: auto;
`;

const ConnectionArt = styled.img`
    position: absolute;
    right: -10px;
    bottom: -30px;
    width: 170px;
    opacity: 0.65;
    pointer-events: none;
    user-select: none;
`;
